'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Pervasives = require("bs-platform/lib/js/pervasives.js");

function ColorToggle(Props) {
  var setToggle = Props.setToggle;
  var toggle = Props.toggle;
  React.useEffect((function () {
          var match = localStorage.getItem("colorBases");
          if (match !== null) {
            Curry._1(setToggle, (function (param) {
                    return Pervasives.bool_of_string(match);
                  }));
          } else {
            localStorage.setItem("colorBases", Pervasives.string_of_bool(toggle));
          }
          return ;
        }), ([]));
  React.useEffect((function () {
          localStorage.setItem("colorBases", Pervasives.string_of_bool(toggle));
          return ;
        }), [toggle]);
  return React.createElement(React.Fragment, undefined, React.createElement("label", {
                  htmlFor: "color-toggle"
                }, "Color bases:"), React.createElement("input", {
                  id: "color-toggle",
                  checked: toggle,
                  type: "checkbox",
                  onChange: (function (param) {
                      return Curry._1(setToggle, (function (oldValue) {
                                    return !oldValue;
                                  }));
                    })
                }));
}

var make = ColorToggle;

exports.make = make;
/* react Not a pure module */
